<div class="description-main">
  <div class="top-part" *ngIf="consumers.length > 0 && consumers[0].type === 'consumer'">
    <div class="header">
      <label class="name" *ngIf="!isEditMode">{{ consumers[0]?.name }}</label>
    </div>
    <label class="category">{{ consumers[0]?.buildingType ? consumers[0].buildingType.name : 'Verbraucher' }}</label>
  </div>
  <p class="description" *ngIf="!isEditMode">
    {{
      consumers[0]?.description !== '' && consumers[0]?.description !== null
        ? consumers[0]?.description
        : ('module.energyMap.descriptionComponent.commentPlaceholderText' | translate)
    }}
  </p>
  <div class="body">
    <ul class="assets-list" *ngIf="consumers.length > 0">
      <li class="list" *ngFor="let consumer of consumers; trackBy: trackByFnConsumer">
        <button type="button" class="btn btn-primary -border" (click)="selectAsset(consumer)">
          {{ displayConsumerName(consumer) }}
        </button>
      </li>
    </ul>
    <ul class="assets-list">
      <li class="list" *ngFor="let type of plantTypes; trackBy: trackByFnPlantType">
        <button type="button" class="btn btn-white -border" (click)="selectPlantType(type)">
          {{ type }}
        </button>
      </li>
    </ul>
  </div>
</div>
